import { render, staticRenderFns } from "./EWTrxActivityTypeList.vue?vue&type=template&id=96e02b0e&"
import script from "./EWTrxActivityTypeList.vue?vue&type=script&lang=js&"
export * from "./EWTrxActivityTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports